import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import { SetProcessing, SetBooking, SetLockout } from '../../../actions/currentBooking';
import { BookingError } from '../../../actions/booking';
import _has from 'lodash/has';
import Spinner from '../../shared/spinner';
import ReactGA from 'react-ga';

class CapacityModal extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      datesAvailable:false,
      noCapacityData:false,
      checkouterror:false
    }
    this.onProductBasketClose = this.onProductBasketClose.bind(this);
    this.onContinueBooking = this.onContinueBooking.bind(this);
  }

  checkForError(){
    if(this.props.basketType === "product"){
      document.querySelector('.basket-product').classList.add('has-error');
    }
  }

  componentDidUpdate(prevProps, prevState) {


    const {
      liveCapacity,
      capacity,
      currentTrip:{ departure_date },
      SetProcessing,
      SetBooking,
      SetLockout,
      checkouterror,
      passengers,
      product
    } = this.props;


    //Live capacity checks
    if(liveCapacity !== prevProps.liveCapacity){

      if (liveCapacity.length === 0) {
        //no date avaiable - show error message
        this.checkForError();
        SetProcessing(true);
        SetBooking(true);
        this.setState({ datesAvailable: true });
        ReactGA.pageview("book.busabout.com/modal/live-capacity-error-nodates-modal");
        return;
      }

      if(_has(liveCapacity, 'errors')){
          //catch error response
        this.checkForError();
        SetProcessing(true);
        SetBooking(true);
        this.setState({checkouterror:true});
        ReactGA.pageview('book.busabout.com/modal/live-capacity-error-500-modal');
        return;
      }else{

        if(liveCapacity.length !== 0 && liveCapacity[0].units === 0){
          //no date avaiable - show error message
          this.checkForError();
          SetProcessing(true);
          SetBooking(true);
          this.setState({datesAvailable:true});
          ReactGA.pageview('book.busabout.com/modal/live-capacity-error-nodates-modal');
          return;
        }

        if(liveCapacity.length !== 0 && passengers.length > liveCapacity[0].units ){
          //no capacity
          this.checkForError();
          SetProcessing(true);
          SetBooking(true);
          this.setState({datesAvailable:true});
          ReactGA.pageview('book.busabout.com/modal/live-capacity-error-nodates-modal');
          return;
        }else{

          //display lockout error modal if difference of the departure date and todays date is less than the lockout date
          if(dayjs(departure_date).diff(dayjs(new Date()), 'day') < product.lockout){
            SetLockout(true);
          }

          this.onContinueBooking();
        }
      }


    }

    //Capacity checks
    if(capacity !== prevProps.capacity){
      //no capacity dates - show error message
      if(capacity.length === 0){

        this.checkForError();
        SetProcessing(true);
        this.setState({noCapacityData:true});
        ReactGA.pageview('book.busabout.com/modal/live-capacity-error-nodates-modal');
      }
    }

    //Checkout errors
    if(checkouterror !== prevProps.checkouterror){
      if(!checkouterror){

        this.checkForError();
        SetProcessing(true);
        this.setState({checkouterror:true});
        ReactGA.pageview('book.busabout.com/modal/live-capacity-error-checkout-modal');
      }
    }

  }

  onContinueBooking(){

    const { SetProcessing, SetBooking, basketType, basketAction } = this.props;

    this.setState({datesAvailable:false, noCapacityData:false, checkouterror:false});

    SetProcessing(false);
    SetBooking(false);


    if(basketType === "product"){
      basketAction('slide2');
    }
  }


  renderProcessingLoader(){
    if(this.props.processing) return <Spinner text="Checking prices and availability..." loadClass="orange-spinner-wrapper" />
  }

  renderBookingLoader(){
    if(this.props.booking) return <Spinner text="Confirming selection..." loadClass="orange-spinner-wrapper" />
  }

  onProductBasketClose(){

    this.props.SetLockout(false);

    if(this.props.basketType === "product"){
      this.setState({ datesAvailable:false, noCapacityData:false, checkouterror:false});
      this.props.BookingError();
      this.props.SetProcessing(false);
      document.querySelector('.basket-product').classList.remove('has-error');
    }
  }

  render(){

    const { noCapacityData, datesAvailable, checkouterror } = this.state;

    return (

        <div className={`error-container ${this.props.basketType} `}>
          <div className="row">

            <div className="column small-12" style={{ display: (noCapacityData || datesAvailable || checkouterror) ? "none" : "block" }}>
              {this.renderProcessingLoader()}
              {this.renderBookingLoader()}
            </div>

            <div className="column small-12">
              <p className="ba-icon ba_icon_extra_info_alt" style={{ display: (noCapacityData || datesAvailable || checkouterror) ? "block" : "none" }} />

              <div style={{ display: !noCapacityData ? "none" : "block" }}>
                <p>{this.props.errorMessages["PRODUCT_CAPACITY"]}</p>
              </div>

              <div style={{ display: !datesAvailable ? "none" : "block" }}>
                <p>{this.props.errorMessages["PRODUCT_CAPACITY"]}</p>
              </div>


              <div style={{ display: !checkouterror ? "none" : "block" }}>
                <p>{this.props.errorMessages["BOOKING_ERROR"]}</p>
              </div>

              <div className="button-container" style={{display: (this.props.basketType === "product" && noCapacityData) || datesAvailable || checkouterror  ? "block" : "none" }}>
                  <button type="button" className="error-close-button" onClick={this.onProductBasketClose}></button>
              </div>

            </div>
          </div>
        </div>
    )
  }

}


function mapStateToProps(state){
  return {
    currentTrip:state.currentBooking.trips[0],
    liveCapacity:state.liveCapacity.data,
    capacity:state.capacity.data,
    processing:state.currentBooking.processing,
    booking:state.currentBooking.booking,
    errorMessages:state.errorMessages,
    checkouterror:state.bookingGroup.isValid,
    passengers:state.currentBooking.passengers,
    product:state.product.header
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetProcessing,
    SetBooking,
    SetLockout,
    BookingError
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CapacityModal);



// WEBPACK FOOTER //
// ./src/components/departure/components/capacitymodal.js